const appScheme = process.env.NEXT_PUBLIC_APP_SCHEME || "id.s.mobile";
export default appScheme;
